export default "__VITE_ASSET__DBhp82Mc__"